import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Show } from '../../Layout';
import { withRouter } from 'react-router';
import LoadingSpinner from "../../Layout/LoadingSpinner";
import { authRegistration } from "./auth.actions";
import Language from "../../Languages/Login/content.json"
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';
import { registerDict } from 'Languages/RegistrationTranslations';
import { AuthAPI } from "../../API";
import signupHeader from '../../assets/img/logoen-dxpanel.png';
import headerImage from '../../assets/img/signin-opinion.png';
import signUpImg from '../../assets/img/forwardarrow.png';
import hindiMainHeaderLogo from '../../assets/img/DXPanel-Hindi-Logo-without-BG.png';
import hindiSignUpImg from '../../assets/img/signuphindi.png';
import { checkNumberValidation, checkStrongPassword } from "../../Helper/Validations";
import { getVerisoulSessionId } from '../../Utils/verisoulHelper';
import { changePasswordDict } from 'Languages/ContactsTranslations';
import countryConfig from 'config/countryConfig';
import { myIpData } from 'Helper/EncryptionDecryption';
import SimpleCaptcha from "./Capcha";
import PropTypes from "prop-types";
import { branding, PORTAL_CODE } from '../../config/portalBranding';
import LanguageToggle from '../Common/LanguageToggle';
import MetaPixel from '../Common/MetaPixel';
import './Login.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Phone field on signup is India-only. Other portals (JP/UK/SG/PH/MY) signed
// up email-only since 2026-05-04; this flag preserves that behaviour by
// gating the JSX, payload, and submit-button condition together.
const IS_INDIA_PORTAL = PORTAL_CODE === 'IN';

class Registration extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      gender: '',
      password: '',
      confirmPassword: '',
      registerType: 'password',
      show: false,
      showConfirmPassword: false,
      phoneNumberActive: false,
      emailActive: false,
      passwordActive: false,
      confirmPasswordActive: false,
      isPasswordMatched: false,
      referralId: '',
      loginRewardType: '',
      loginLocation: '',
      loginStoreId: '',
      pageContent: this.props.language === 'jp' ? Language.SignupJapanese : this.props.language === 'hi' ? Language.SignupHindi : Language.SignupEnglish,
      error: {
        status: false,
        message: ''
      },

      captcha: process.env.REACT_APP_DISABLE_CAPTCHA === 'true', // bypass on local
      isPasswordVisible: false,
      isRepeatPasswordVisible: false,
      email_otp: '',
      emailValid: false, // Track email validity
      phoneNumber: '',
      phoneOtp: '',
      // Phone OTP verification flag. Mirrors isEmailOtpValid for the phone leg.
      // India-only feature; non-IN portals never set this to true and the
      // submit-gate at isSubmitButtonDisable doesn't require it for them.
      phoneOtpVerified: false,
      phoneValid: false, // Track phone number validity
      isLoading: false, // Loader state
      countdown: 60, // Countdown in seconds
      isCountdownActive: false, // Track if countdown is active
      errorMessage: '',
      // Email verification state
      isEmailOtpValid: false,
      isLoadingEmail: false,
      showOtpSentMessage: false,
      isCountdownActiveEmail: false,
      countdownEmail: 60,
      errorMessageEmail: '',

      // Phone verification state
      isLoadingPhone: false,
      showOtpSentMessagePhone: false,
      isCountdownActivePhone: false,
      countdownPhone: 60,
      errorMessagePhone: '',
      isButtonDisabled: false, // Initially enabled
      isValidPassword: true,
      notValidPasswordText: "",
      isValidConfirmPassword: true,
      notValidConfirmPasswordText: "",
      isEmailValueChanged: false,
      isPhoneNumberChanged: false,
    };
    this.emailTimer = null;
    this.phoneTimer = null;
    this.setCaptcha = this.setCaptcha.bind(this);
    this.updateCaptcha = this.updateCaptcha.bind(this);
  }

  setCaptcha(newCaptchaValue) {
    this.setState({ captcha: newCaptchaValue });
  }

  updateCaptcha(newCaptchaValue) {
    this.setState({ captcha: newCaptchaValue });
  }
  componentDidMount() {
    // Read params from the hash-internal query string. window.location.search
    // is empty for hash routes; the real params live after the '?' inside the
    // hash fragment. After normalizeTrackingParams() runs at bootstrap, pre-hash
    // tracking params (fbclid, gclid, utm_*) are already merged here too.
    const hashQuery = window.location.hash.split('?')[1] || '';
    const urlSearchParams = new URLSearchParams(hashQuery);
    const referralId = urlSearchParams.get('referralId');
    if (referralId) {
      this.setState({ referralId })
    }
    const loginRewardType = urlSearchParams.get('loginRewardType');
    const loginLocation = urlSearchParams.get('loginLocation');
    // storeid is used by ChaiPoint; the backend persists it as loginStoreId.
    const loginStoreId = urlSearchParams.get('storeid') || urlSearchParams.get('storeId') || urlSearchParams.get('loginStoreId') || '';

    // Set them independently so that missing loginLocation does not wipe out loginRewardType
    if (loginRewardType) this.setState({ loginRewardType });
    if (loginLocation) this.setState({ loginLocation });
    
    // Capture storeid regardless of portal — it's always attribution/gate data.
    if (loginStoreId) this.setState({ loginStoreId })
  }

  validate(password, confirmPassword) {
    return password === confirmPassword
  }

  // ===================== Email Verificatiomn=========================
  componentWillUnmount() {
    clearInterval(this.emailTimer);
    clearInterval(this.phoneTimer);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.error != this.props.error) {
      if (this.props.error && this.props.error !== '') {
        let errorMessage = '';

        switch (this.props.error) {
          case "Invalid Token":
            document.getElementById('view_tokenexpire').style.display = "block";
            document.getElementById('inputPsw1').style.display = "none";
            document.getElementById('inputPsw2').style.display = "none";
            // commented code document.querySelector('.privacy_error').style.display = "none";
            break;
          case "User registered successfully!":
            errorMessage = `${this.state.pageContent.items[32].title}`;
            break;
          case "Failed! email is already in use!":
            errorMessage = `${this.state.pageContent.items[28].title}`;
            break;
          case "Failed! phone number is already in use!":
            errorMessage = `${this.state.pageContent.items[29].title}`;
            break;
          case "Failed! Email does not exist!":
            errorMessage = `${this.state.pageContent.items[30].title}`;
            break;
          case "Invalid phone number. Only digits are allowed.":
            errorMessage = `${this.state.pageContent.items[31].title}`;
            break;
          case "Failed! your account has been deleted; for reactivation or a new account, please contact DX Panel support.":
            errorMessage = `${this.state.pageContent.items[34].title}`.replace("{brand}", countryConfig.brandName);
            break;
          default:
            // Show the actual backend message when the switch has no specific case for it.
            // Falls back to the localized generic only when the backend gave us nothing.
            errorMessage = this.props.error || (this.props.language === 'jp' ? '不明なエラーが発生しました。' : 'An unknown error occurred.');
        }

        this.setState({
          error: {
            status: true,
            message: errorMessage
          },
          isButtonDisabled: false
        });
      } else {
        this.setState({
          isButtonDisabled: true,
          error: {
            status: false,
            message: ''
          }
        });
      }
    }
  };

  // ======================== EMAIL VERIFICATION ================================

  handleEmailChangenew = async (e) => {
    const { value } = e.target;
    await new Promise((resolve) =>
      this.setState({
        email: value,
        isEmailValueChanged: true,
        isEmailOtpValid: false,
        error: { status: false, message: '' }
      }, resolve)
    )
  }

  handleEmailChange = async (e) => {
    const { value } = e.target;
    await new Promise((resolve) =>
      this.setState((prevVal) => {
        if (prevVal.isEmailValueChanged) {
          return {
            email: value,
            emailValid: e.target.validity.valid,
            email_otp: '',
            showOtpSentMessage: false,
            countdownEmail: 60,
            isCountdownActiveEmail: false,
            errorMessageEmail: '',
          };
        } else {
          return { email: value };
        }
      }, resolve)
    );

    const { email, emailValid, isEmailValueChanged } = this.state;

    if (emailValid && isEmailValueChanged) {
      this.setState({ isLoadingEmail: true });
      try {
        const response = await AuthAPI.NewcontinueWithMobile({ email, type: "email", language: this.props.language });

        if (response.status === 1) {
          document.getElementById('email_otp_field').style.display = 'block';
          document.getElementById('email_text').style.display = 'none';

          this.startEmailTimer();
          this.setState({ showOtpSentMessage: true });
        } else {
          this.setState({ errorMessageEmail: response.message });
        }
      } catch (error) {
        console.error("An error occurred:", error);
        this.setState({ errorMessageEmail: this.props.language === 'jp' ? "OTPの送信中にエラーが発生しました。" : this.props.language === 'hi' ? "An error occurred while sending OTP." : "An error occurred while sending OTP." });
      } finally {
        this.setState({ isLoadingEmail: false, isEmailValueChanged: false });
      }
    }
  };
  startEmailTimer = () => {
    // Clear any existing interval timer
    if (this.emailTimer) {
      clearInterval(this.emailTimer);
    }

    this.setState({ isCountdownActiveEmail: true, countdownEmail: 60 });
    this.emailTimer = setInterval(() => {
      const { countdownEmail } = this.state;
      if (countdownEmail > 0) {
        this.setState({ countdownEmail: countdownEmail - 1 });
      } else {
        clearInterval(this.emailTimer);
        this.setState({ isCountdownActiveEmail: false });
      }
    }, 1000);
  };

  handleResendOtpEmail = async () => {
    const { email } = this.state;
    try {
      this.setState({ isLoadingEmail: true, showOtpSentMessage: false });
      const response = await AuthAPI.NewcontinueWithMobile({ email, type: "email", language: this.props.language });

      if (response.status === 1) {

        this.setState({ showOtpSentMessage: true, countdownEmail: 60, isCountdownActiveEmail: true });
        this.startEmailTimer();
      } else {
        this.setState({ errorMessageEmail: response.message });
      }
    } catch (error) {
      console.error("An error occurred while resending OTP:", error);
      this.setState({ errorMessageEmail: this.props.language === 'jp' ? "OTPの再送信中にエラーが発生しました。" : this.props.language === 'hi' ? "An error occurred while resending OTP." : "An error occurred while resending OTP." });
    } finally {
      this.setState({ isLoadingEmail: false });
    }
  };

  handleVerifyEmailOtp = async () => {
    const { email, email_otp } = this.state;
    const data = {
      type: "email",
      otp: email_otp,
      email: email,
      language: this.props.language
    };

    try {
      this.setState({ isLoadingEmail: true });
      const response = await AuthAPI.newverifyMobile(data);

      if (response.status === 1) {
        document.getElementById('otpsend').style.display = 'none'; //otpsend
        document.getElementById('email_otp_field').style.display = 'none';
        document.getElementById('email_text').style.display = 'block';
        document.getElementById('invalidmsgmail').style.display = 'none';
        this.setState({
          showOtpSentMessage: false,
          errorMessageEmail: '',
          isEmailOtpValid: true,
        });
      } else {
        this.setState({ errorMessageEmail: this.props.language === 'jp' ? "OTPが無効です。もう一度お試しください。" : this.props.language === 'hi' ? "Invalid OTP. Please try again." : "Invalid OTP. Please try again.", isEmailOtpValid: false });
      }
    } catch (error) {
      document.getElementById('invalidmsgmail').style.display = 'block';
      console.error("An error occurred:", error);
      this.setState({ errorMessageEmail: this.props.language === 'jp' ? "OTPの確認中にエラーが発生しました。" : this.props.language === 'hi' ? "An error occurred while verifying OTP." : "An error occurred while verifying OTP.", isEmailOtpValid: false });
    } finally {
      this.setState({ isLoadingEmail: false });
    }
  };
  handleChange = async (e) => {
    const { name, value } = e.target;
    if (checkNumberValidation(e)) { return }
    if (name === 'email_otp' && value.length == 0) { document.getElementById('invalidmsgmail').style.display = 'none'; }
    await new Promise((resolve) =>
      this.setState({
        [name]: value.trim(),
        isEmailOtpValid: false,
      }, resolve)
    )
    // Automatically verify OTP when it reaches the required length
    if (name === 'email_otp' && value.length === 4) {
      this.handleVerifyEmailOtp();
    }
  };
  // ======================== PHONE VERIFICATION ================================
  handlePhoneNumberChange = async (e) => {
    const { value } = e.target;
    await new Promise((resolve) =>
      this.setState({
        phoneNumber: value.trim(),
        isPhoneNumberChanged: true,
        error: { status: false, message: '' }
      }, resolve)
    )
  }
  handlePhoneChange = async (e) => {
    // Phone OTP verification — India-only. Non-IN portals never render the
    // phone field at all (JSX gate at line ~887), so this handler is never
    // wired up. The IS_INDIA_PORTAL guard on the API call is defense-in-depth.
    if (!IS_INDIA_PORTAL) return;
    document.getElementById('phone_otp_field').style.display = "block";
    document.getElementById('phone_text').style.display = "none";
    const { value } = e.target;
    if (checkNumberValidation(e)) { return }
    await new Promise((resolve) =>
      this.setState((prevVal) => {
        if (prevVal.isPhoneNumberChanged) {
          return {
            phoneNumber: value.trim(),
            phoneValid: e.target.validity.valid && value.length === 10,
            phoneOtp: '', // Clear OTP when phone number changes
            phoneOtpVerified: false, // Re-verification required if phone number changes
            showOtpSentMessagePhone: false,
            countdownPhone: 60,
            isCountdownActivePhone: false,
            errorMessagePhone: '',
          }
        } else {
          return { phoneNumber: value.trim() }
        }
      }, resolve)
    )

    if (this.state.phoneValid && this.state.isPhoneNumberChanged) {
      this.setState({ isLoadingPhone: true });
      try {
        const response = await AuthAPI.NewcontinueWithMobile({ phoneNumber: this.state.phoneNumber, type: "mobile", language: this.props.language });

        if (response.status === 1) {
          this.startPhoneTimer();
          this.setState({ showOtpSentMessagePhone: true });
          const phonesend = document.getElementById('phonesend');
          if (phonesend) {
            phonesend.style.display = 'flex';
          }
        } else {
          this.setState({ errorMessagePhone: response.message });
        }
      } catch (error) {
        console.error("An error occurred:", error);
        this.setState({ errorMessagePhone: "An error occurred while sending OTP." });
      } finally {
        this.setState({ isLoadingPhone: false, isPhoneNumberChanged: false });
      }
    }
  };
  startPhoneTimer = () => {
    // Pure timer logic, no API. Only ever invoked from India-only handlers
    // above (handlePhoneChange / handleResendOtpPhone) — non-IN portals can't
    // reach this code path.
    if (this.phoneTimer) {
      clearInterval(this.phoneTimer);
    }

    this.setState({ isCountdownActivePhone: true, countdownPhone: 60 });
    this.phoneTimer = setInterval(() => {
      const { countdownPhone } = this.state;
      if (countdownPhone > 0) {
        this.setState({ countdownPhone: countdownPhone - 1 });
      } else {
        clearInterval(this.phoneTimer);
        this.setState({ isCountdownActivePhone: false });
      }
    }, 1000);
  };

  handleResendOtpPhone = async () => {
    // India-only — non-IN portals never wire this handler (button is JSX-gated).
    if (!IS_INDIA_PORTAL) return;
    const { phoneNumber } = this.state;
    try {
      this.setState({ isLoadingPhone: true, showOtpSentMessagePhone: false });
      const response = await AuthAPI.NewcontinueWithMobile({ phoneNumber, type: "mobile", language: this.props.language });

      if (response.status === 1) {
        this.setState({ showOtpSentMessagePhone: true, countdownPhone: 60, isCountdownActivePhone: true });
        this.startPhoneTimer();
        const phonesend = document.getElementById('phonesend');
        if (phonesend) {
          phonesend.style.display = 'flex';
        }
      } else {
        console.error("Failed to resend OTP:", response.message);
      }
    } catch (error) {

      console.error("An error occurred while resending OTP:", error);
    } finally {
      this.setState({ isLoadingPhone: false });
    }
  };

  handleVerifyPhoneOtp = async () => {
    // India-only — non-IN portals never trigger this (handleOtpChange is gated
    // and the OTP input field is JSX-gated). Belt-and-suspenders guard below.
    if (!IS_INDIA_PORTAL) return;
    const { phoneNumber, phoneOtp } = this.state;
    const data = {
      type: 'mobile',
      phoneNumber: phoneNumber,
      otp: phoneOtp,
      language: this.props.language
    };

    try {
      this.setState({ isLoadingPhone: true });
      const response = await AuthAPI.newverifyMobile(data);

      if (response.status === 1) {
        document.getElementById('inputPsw1').style.display = "block";
        document.getElementById('inputPsw2').style.display = "block";
        document.getElementById('phone_text').style.display = "block";
        document.getElementById('phone_otp_field').style.display = "none";
        document.getElementById('invalidmsphone').style.display = "none";
        const phonesend = document.getElementById('phonesend');
        if (phonesend) {
          phonesend.style.display = "none";
        }
        this.setState({
          showOtpSentMessagePhone: false,
          errorMessagePhone: '',
          // Mirrors isEmailOtpValid on the email leg — drives the submit-button
          // gate at isSubmitButtonDisable so signup can proceed.
          phoneOtpVerified: true,
        });
      } else {
        console.error(`Unexpected status code: ${response.status}`);
        this.setState({ errorMessagePhone: "Invalid OTP. Please try again.", phoneOtpVerified: false });
      }
    } catch (error) {
      document.getElementById('invalidmsphone').style.display = "block";
      console.error("An error occurred:", error);
      this.setState({ errorMessagePhone: "An error occurred while verifying OTP.", phoneOtpVerified: false });
    } finally {
      this.setState({ isLoadingPhone: false });
    }
  };
  handleOtpChange = async (e) => {
    // India-only — non-IN portals never render the OTP input field (JSX gate).
    if (!IS_INDIA_PORTAL) return;
    const { value } = e.target;
    if (checkNumberValidation(e)) { return }
    await new Promise((resolve) =>
      this.setState({
        phoneOtp: value.trim(),
      }, resolve)
    )
    if (value.length < 1) { document.getElementById('invalidmsphone').style.display = "none"; }
    if (e.target.validity.valid && value.length === 4) {
      this.handleVerifyPhoneOtp();
    }
  };

  onSubmit() {
    this.setState({ isButtonDisabled: true }, async () => {
      // Check if policy is accepted
      if (!this.state.policy) {
        this.setState({ show: true, isButtonDisabled: false }, () => {
        });
        return;
      }
      // Validate passwords
      if (!this.validate(this.state.password, this.state.confirmPassword)) {
        this.setState({ showConfirmPassword: true, isButtonDisabled: false }, () => {
        });
        return;
      }
      // Check if captcha is completed
      if (!this.state.captcha) {
        this.setState({
          error: {
            status: true,
            message: this.props.language === 'jp' ? 'キャプチャを完了してください。' : this.props.language === 'hi' ? 'Please complete the captcha.' : 'Please complete the captcha.'
          },
          isButtonDisabled: false
        }, () => {
        });
        return;
      }

      // Fetch Verisoul Session ID reliably with ready-wait polling
      const verisoulSessionId = await getVerisoulSessionId();

      // Prepare data for registration
      const data = {
        email: this.state.email,
        // India-only phone field. Non-IN portals always send '' so the
        // backend's `req.body.phoneNumber || null` resolves to null,
        // preserving the email-only signup behaviour shipped 2026-05-04.
        phoneNumber: IS_INDIA_PORTAL ? this.state.phoneNumber : '',
        password: this.state.password,
        registerType: this.state.registerType,
        role: myIpData("panelist"),
        referralId: this.state.referralId,
        loginRewardType: this.state.loginRewardType,
        loginLocation: this.state.loginLocation,
        loginStoreId: this.state.loginStoreId,
        language: this.props.language,
        // India-only phone OTP. Non-IN portals send '' so the backend treats it
        // as absent — mirrors the phoneNumber gate at line ~539 above.
        mobileOTP: IS_INDIA_PORTAL ? this.state.phoneOtp : '',
        emailOTP: this.state.email_otp,
        verisoulSessionId,
      };

      // Read regType from the hash-internal query string, same as componentDidMount.
      const hashQueryOnSubmit = window.location.hash.split('?')[1] || '';
      const submitParams = new URLSearchParams(hashQueryOnSubmit);
      const regType = submitParams.get('regType');
      if (regType) data.regType = regType;
      // Call the registration function
      this.props.authRegistration(data, this.props.history);
    });
  }

  isSubmitButtonDisable() {
    return !!this.state.email &&
      // Phone is only a required submit-gate on the India portal. Other
      // portals don't render the field, so checking it would permanently
      // block their submit button. India additionally requires the phone
      // OTP to be verified (mirrors the email-OTP gate via isEmailOtpValid).
      (!IS_INDIA_PORTAL || (!!this.state.phoneNumber && !!this.state.phoneOtpVerified)) &&
      !!this.state.password &&
      !!this.state.confirmPassword &&
      !!this.state.captcha &&
      !!this.state.isEmailOtpValid
  }

  isPasswordStrong(ele, type) {
    const { value } = ele.target;
    const isHindi = this.props.language === 'hi';
    if (value === "") {
      const stateUpdate = {
        [type === "password" ? 'isValidPassword' : 'isValidConfirmPassword']: true,
        [type === "password" ? 'notValidPasswordText' : 'notValidConfirmPasswordText']: "",
        isButtonDisabled: false
      };
      this.setState(stateUpdate);
      return;
    }
    const isJapanese = this.props.language === 'jp';
    const passwordChecks = checkStrongPassword(ele);
    const getLabel = () => {
      if (type === 'password') { return isJapanese ? "パスワード" : isHindi ? "पासवर्ड" : "Password"; }
      return isJapanese ? "確認用パスワード" : isHindi ? "कन्फर्म पासवर्ड" : "Confirm password";
    };
    const errorMessages = [
      {
        condition: passwordChecks.capitalLatterCheck,
        message: isJapanese ? "には大文字を1文字以上含める必要があります" : isHindi ? " में एक बड़ा अक्षर होना चाहिए" : " should contain one capital letter"
      },
      {
        condition: passwordChecks.smallLatterCheck,
        message: isJapanese ? "には小文字を1文字以上含める必要があります" : isHindi ? " में एक छोटा अक्षर होना चाहिए" : " should contain one small letter"
      },
      {
        condition: passwordChecks.numericValCheck,
        message: isJapanese ? "には数字を1文字以上含める必要があります" : isHindi ? " में एक संख्यात्मक मान होना चाहिए" : " should contain one numeric value"
      },
      {
        condition: passwordChecks.specialCharCheck,
        message: isJapanese ? "には特殊文字を1文字以上含める必要があります" : isHindi ? " में एक विशेष प्रतीक होना चाहिए" : " should contain one special character"
      },
      {
        condition: passwordChecks.lengthCheck,
        message: isJapanese ? "は8文字以上である必要があります" : isHindi ? " की लंबाई कम से कम 8 अक्षर की होनी चाहिए" : " length should be atleast of 8 character"
      },
    ];
    const firstFailed = errorMessages.find(error => !error.condition);
    const isAllValid = errorMessages.every(error => error.condition);
    const label = getLabel();
    const stateUpdate = {
      [type === "password" ? 'isValidPassword' : 'isValidConfirmPassword']: isAllValid,
      [type === "password" ? 'notValidPasswordText' : 'notValidConfirmPasswordText']: isAllValid ? "" : label + firstFailed.message,
      isButtonDisabled: !isAllValid
    };
    this.setState(stateUpdate);
  }

  onChangePassword(value, type) {

    let { password, confirmPassword } = this.state;
    if (type === 'confirmpassword') {
      confirmPassword = value;
    } else {
      password = value;
    }

    if (password !== '' && confirmPassword !== '' && password === confirmPassword) {
      this.setState({
        isPasswordMatched: true
      })
    } else {
      this.setState({
        isPasswordMatched: false
      })
    }
  }

  onLogin() {
    if (this.state.referralId) {
      const queryParams = {
        referralId: this.state.referralId,
      };
      const queryString = Object.keys(queryParams)
        .map(key => `${key}=${encodeURIComponent(queryParams[key])}`)
        .join('&');
      const loginUrl = `/auth/login?${queryString}`;
      this.props.history.push(loginUrl)
    } else if (this.state.loginRewardType && this.state.loginLocation) {
      const queryParams = {
        loginRewardType: this.state.loginRewardType,
        loginLocation: this.state.loginLocation,
      };
      const queryString = Object.keys(queryParams)
        .map(key => `${key}=${encodeURIComponent(queryParams[key])}`)
        .join('&');
      const loginUrl = `/auth/login?${queryString}`;
      this.props.history.push(loginUrl)
    }
     else {
      this.props.history.push('/login')
    }
  }

  render() {
    const conditionalVarObj = {
      true: {
        "mainCardPadding": "p-3",
        "headerImgWidth": "30%",
        "allParagraph": '20px',
        "allVisibleBtn": "25px",
        "partition": "या",
        "inputPsIcon": "fa fa-eye-slash",
        "newUserPadding": "0.3rem",
        "fbText": "फेसबुक से जुड़ें",
        "inputPsType": "text",
        "respoMsg": "18px",
        "password": "पासवर्ड",
        "confirmPassword": "कन्फर्म पासवर्ड",
        "checkBoxSize": "18px",
      },
      false: {
        "mainCardPadding": "p-2",
        "headerImgWidth": "13%",
        "allParagraph": '16px',
        "allVisibleBtn": "16px",
        "partition": "OR",
        "inputPsIcon": "fa fa-eye",
        "newUserPadding": "0.1rem",
        "fbText": "Connect with facebook",
        "inputPsType": "password",
        "respoMsg": "16px",
        "password": "Password",
        "confirmPassword": "Confirm password",
        "checkBoxSize": "12px",
      },
    };
    const {
      email,
      emailValid,
      email_otp,
      countdownEmail,
      showOtpSentMessage,
      isCountdownActiveEmail,
      errorMessageEmail,
    } = this.state;

    const {
      showOtpSentMessagePhone,
      phoneNumber,
      phoneValid,
      phoneOtp,
      isLoadingPhone,
      isCountdownActivePhone,
      countdownPhone,
      errorMessagePhone,
    } = this.state;

    const { isPasswordMatched, pageContent, isValidPassword, notValidPasswordText, isValidConfirmPassword, notValidConfirmPasswordText, } = this.state;
    const lang = this.props.language ?? 'en';
    // The Japanese signup layout sources its left-panel + heading copy from
    // content.json (SignupJapanese.panel); other portals keep the existing
    // hardcoded/branding-driven rendering unchanged. Brand placeholders use
    // the bug #5 .replace("{brand}", ...) pattern.
    const isJapanese = lang === 'jp';
    const withBrand = (str) => (str || '').replace("{brand}", countryConfig.brandName);
    return (
      <>
        <MetaPixel />
        <Helmet>
          <title>{`${branding.name} - Sign up`}</title>
        </Helmet>
        <section className="dxAuth-shell" style={{
          '--dx-primary': branding.primaryColor,
          '--dx-secondary': branding.secondaryColor || branding.primaryColor,
          '--dx-accent': branding.accentColor || branding.secondaryColor || branding.primaryColor,
          // Country-aware auth background image (JP-only pattern; see Login.css
          // [data-country="JP"]). Other portals keep their solid gradient panel.
          '--dx-login-bg': branding.loginBg ? `url("${branding.loginBg}")` : 'none',
        }}>
          <aside className="dxAuth-leftPanel" data-country={branding.code}>
            <div className="dxAuth-leftPanel-glow" aria-hidden="true" />
            <div className="dxAuth-leftLogoWrap">
              <img
                src={lang == "hi" ? hindiMainHeaderLogo : (branding.logoFront || signupHeader)}
                alt={branding.name}
                className="dxAuth-leftLogo"
                onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = signupHeader; }}
              />
            </div>
            <div className="dxAuth-leftContent">
              <div className="dxAuth-leftAccentTop" aria-hidden="true" />
              <h1 className="dxAuth-leftHeadline">
                <span className="dxAuth-leftHeadline-bold">
                  {isJapanese ? pageContent.panel.headlineBold : 'Share your opinion.'}
                </span>
                <span className="dxAuth-leftHeadline-light">
                  {isJapanese ? pageContent.panel.headlineLight : 'Earn rewards.'}
                </span>
              </h1>
              <p className="dxAuth-leftSubheadline">
                {isJapanese
                  ? withBrand(pageContent.panel.subheadline)
                  : (branding.tagline
                    ? `${branding.tagline} — join thousands of panelists shaping market research across ${branding.name}.`
                    : `Join thousands of panelists shaping market research across ${branding.name}.`)}
              </p>
            </div>
            <p className="dxAuth-leftFooter">
              {isJapanese
                ? withBrand(pageContent.panel.footer)
                : `© ${new Date().getFullYear()} ${branding.name} • Powered by DataXing`}
            </p>
          </aside>

          <main className="dxAuth-rightPanel">
            <div className="dxAuth-mobileLogoBar">
              <img
                src={lang == "hi" ? hindiMainHeaderLogo : (branding.logo || signupHeader)}
                alt={branding.name}
                onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = signupHeader; }}
              />
            </div>

            {this.state.isLoadingEmail && (
              <div className="dxAuth-loaderOverlay">
                <img src="../loadernew.gif" alt="Loading..." />
              </div>
            )}
            {isLoadingPhone && (
              <div className="dxAuth-loaderOverlay">
                <img src="../loadernew.gif" alt="Loading..." />
              </div>
            )}

            <div className="dxAuth-formContainer dxAuth-formContainer--signup">
              <h2 className="dxAuth-heading">
                {isJapanese ? pageContent.panel.signupHeading : 'Create your account'}
              </h2>
              <p className="dxAuth-subheading">{pageContent.items[12].title || 'Join the panel and start earning rewards for your opinions.'}</p>

              <form
                className="dxAuth-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  this.onSubmit();
                }}
              >
                {/* Email Verification Section */}
                <div className="dxAuth-fieldGroup">
                  <label htmlFor="dxAuth-signupEmail" className="dxAuth-label">{pageContent.items[5].title}</label>
                  <input
                    id="dxAuth-signupEmail"
                    type="email"
                    className="dxAuth-input"
                    name="email"
                    value={email}
                    onBlur={this.handleEmailChange}
                    onChange={this.handleEmailChangenew}
                    maxLength={200}
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                    required
                    placeholder={pageContent.items[5].title}
                    autoComplete="email"
                  />
                  {!emailValid && (
                    <div className="invalid-feedback">
                      {pageContent.items[19].title}
                    </div>
                  )}
                  <div
                    className="dxAuth-otpBanner"
                    style={{ display: showOtpSentMessage ? 'flex' : 'none' }}
                    id='otpsend'
                  >
                    <span>{pageContent.items[23].title} ({pageContent.items[24].title} {countdownEmail} sec)</span>
                    <button
                      className='dxAuth-pillBtn'
                      type='button'
                      onClick={this.handleResendOtpEmail}
                      disabled={isCountdownActiveEmail}
                    >
                      {pageContent.items[25].title}
                    </button>
                  </div>
                  <div
                    className="dxAuth-otpBanner"
                    style={{ display: 'none' }}
                    id='email_text'
                  >
                    {pageContent.items[21].title}
                  </div>
                </div>

                <div className="dxAuth-fieldGroup" id='email_otp_field'>
                  <label htmlFor="dxAuth-signupEmailOtp" className="dxAuth-label">{pageContent.items[15].title}</label>
                  <input
                    id="dxAuth-signupEmailOtp"
                    type="text"
                    className="dxAuth-input"
                    name="email_otp"
                    value={email_otp}
                    onChange={this.handleChange}
                    maxLength={4}
                    onInput={(e) => e.target.setCustomValidity('')}
                    required
                    placeholder={pageContent.items[15].title}
                    inputMode="numeric"
                  />
                  <div
                    className="dxAuth-otpBanner dxAuth-otpBanner--error"
                    style={{ display: 'none' }}
                    id='invalidmsgmail'
                  >
                    {pageContent.items[22].title}
                  </div>
                </div>

                {IS_INDIA_PORTAL && (
                  <div className="dxAuth-fieldGroup">
                    <label htmlFor="dxAuth-signupPhone" className="dxAuth-label">{pageContent.items[6].title}</label>
                    <input
                      id="dxAuth-signupPhone"
                      type="text"
                      className="dxAuth-input"
                      name="phone"
                      value={phoneNumber}
                      onChange={this.handlePhoneNumberChange}
                      onBlur={this.handlePhoneChange}
                      maxLength={10}
                      pattern="[6-9]\d{9}"
                      required
                      placeholder={pageContent.items[6].title}
                      onInvalid={(e) => {
                        e.target.setCustomValidity(`${pageContent.items[26].title} `);
                      }}
                      onInput={(e) => e.target.setCustomValidity('')}
                      inputMode="numeric"
                      autoComplete="tel"
                    />
                    {!phoneValid && (
                      <div className="invalid-feedback">
                        {pageContent.items[17].title}
                      </div>
                    )}
                    <div
                      className="dxAuth-otpBanner"
                      style={{ display: showOtpSentMessagePhone ? 'flex' : 'none' }}
                      id='phonesend'
                    >
                      <span>{pageContent.items[23].title} ({pageContent.items[24].title} {countdownPhone} sec)</span>
                      <button
                        className='dxAuth-pillBtn'
                        type='button'
                        onClick={this.handleResendOtpPhone}
                        disabled={isCountdownActivePhone}
                      >
                        {pageContent.items[25].title}
                      </button>
                    </div>
                  </div>
                )}

                {IS_INDIA_PORTAL && (
                  <>
                    <div
                      className="dxAuth-otpBanner"
                      style={{ display: "none" }}
                      id='phone_text'
                    >
                      {pageContent.items[20].title}
                    </div>

                    <div className="dxAuth-fieldGroup" id='phone_otp_field'>
                      <label htmlFor="dxAuth-signupPhoneOtp" className="dxAuth-label">{pageContent.items[16].title}</label>
                      <input
                        id="dxAuth-signupPhoneOtp"
                        type="text"
                        className="dxAuth-input"
                        name="phoneOtp"
                        value={phoneOtp}
                        onChange={this.handleOtpChange}
                        maxLength={4}
                        pattern="\d{4}"
                        required
                        placeholder={pageContent.items[16].title}
                        onInvalid={(e) => {
                          e.target.setCustomValidity(`${pageContent.items[18].title}`);
                        }}
                        onInput={(e) => e.target.setCustomValidity('')}
                        inputMode="numeric"
                      />
                      {!phoneValid && (
                        <div className="invalid-feedback">
                          {pageContent.items[18].title}
                        </div>
                      )}
                      <div
                        className="dxAuth-otpBanner dxAuth-otpBanner--error"
                        style={{ display: 'none' }}
                        id='invalidmsphone'
                      >
                        {pageContent.items[22].title}
                      </div>
                    </div>
                  </>
                )}

                {/* Error Message Display */}
                {(errorMessageEmail || errorMessagePhone) && (
                  <div className="dxAuth-formError">
                    {errorMessageEmail || errorMessagePhone}
                  </div>
                )}

                {/* Password fields: on India, hide until phone OTP verifies (legacy behaviour
                    restored 2026-06-12 alongside the phone OTP re-enablement). On non-IN
                    portals there's no phone OTP, so render them straight away as before. */}
                <div className="dxAuth-fieldGroup" id='inputPsw1' style={{ display: (IS_INDIA_PORTAL && !this.state.phoneOtpVerified) ? "none" : "block" }}>
                  <label htmlFor="dxAuth-signupPassword" className="dxAuth-label">{isJapanese ? pageContent.panel.password : conditionalVarObj[lang == "hi"]["password"]}</label>
                  <div className="dxAuth-passwordWrap">
                    <input
                      id="dxAuth-signupPassword"
                      className="dxAuth-input"
                      name='password'
                      value={this.state.password}
                      type={conditionalVarObj[this.state.isPasswordVisible]["inputPsType"]}
                      onChange={(e) => {
                        this.onChangePassword(e.target.value, 'password');
                        this.setState({ password: e.target.value, })
                      }}
                      onClick={() => this.setState((prev) => { return { ...prev, passwordActive: !prev.passwordActive } })}
                      title={registerDict[lang]['passwordTitle']}
                      pattern="^(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,20}$"
                      onInvalid={(e) => {
                        let msg = registerDict[lang]['validationMessage'] + ': ' + registerDict[lang]['passwordTitle']
                        e.target.setCustomValidity(msg)
                      }}
                      onInput={(e) => this.isPasswordStrong(e, 'password')}
                      placeholder={isJapanese ? pageContent.panel.passwordPlaceholder : conditionalVarObj[lang == "hi"]["password"]}
                      autoComplete="new-password"
                      required
                    />
                    <button
                      type="button"
                      aria-label="Toggle password visibility"
                      onClick={() => this.setState((prev) => { return { ...prev, isPasswordVisible: !prev.isPasswordVisible } })}
                      className={this.state.password.length > 0 ? "dxAuth-passwordToggle" : "dxAuth-passwordToggle dxAuth-passwordToggle--hidden"}
                    >
                      <i className={conditionalVarObj[!this.state.isPasswordVisible]["inputPsIcon"]}></i>
                    </button>
                  </div>
                  {isValidPassword ? "" :
                    <div className="dxAuth-pwError">
                      {notValidPasswordText}
                    </div>}
                </div>

                {/* Confirm-password field: same India-only hide-until-OTP-verified flow as
                    inputPsw1 above. Non-IN portals render unchanged. */}
                <div className="dxAuth-fieldGroup" id='inputPsw2' style={{ display: (IS_INDIA_PORTAL && !this.state.phoneOtpVerified) ? "none" : "block" }}>
                  <label htmlFor="dxAuth-signupConfirmPassword" className="dxAuth-label">{isJapanese ? pageContent.panel.confirmPassword : conditionalVarObj[lang == "hi"]["confirmPassword"]}</label>
                  <div className="dxAuth-passwordWrap">
                    <input
                      id="dxAuth-signupConfirmPassword"
                      className="dxAuth-input"
                      name='confirmpassword'
                      value={this.state.confirmPassword}
                      type={conditionalVarObj[this.state.isRepeatPasswordVisible]["inputPsType"]}
                      pattern="^(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,20}$"
                      onInvalid={(e) => {
                        let msg = registerDict[lang]['validationMessage'] + ': ' + registerDict[lang]['passwordTitle']
                        e.target.setCustomValidity(msg)
                      }}
                      onInput={(e) => this.isPasswordStrong(e, 'confirmpassword')}
                      onChange={(e) => {
                        this.onChangePassword(e.target.value, 'confirmpassword');
                        this.setState({ confirmPassword: e.target.value, })
                      }}
                      onClick={() => this.setState((prev) => { return { ...prev, confirmPasswordActive: !prev.confirmPasswordActive } })}
                      placeholder={isJapanese ? pageContent.panel.confirmPasswordPlaceholder : conditionalVarObj[lang == "hi"]["confirmPassword"]}
                      autoComplete="new-password"
                    />
                    <button
                      type="button"
                      aria-label="Toggle confirm password visibility"
                      onClick={() => this.setState((prev) => { return { ...prev, isRepeatPasswordVisible: !prev.isRepeatPasswordVisible } })}
                      className={this.state.confirmPassword.length > 0 ? "dxAuth-passwordToggle" : "dxAuth-passwordToggle dxAuth-passwordToggle--hidden"}
                    >
                      <i className={conditionalVarObj[!this.state.isRepeatPasswordVisible]["inputPsIcon"]}></i>
                    </button>
                  </div>
                  {isPasswordMatched && isValidPassword && isValidConfirmPassword ?
                    <div className="dxAuth-pwMatched">
                      <i className="fa fa-check"></i>&nbsp;{changePasswordDict[lang]["Passwords Matched"] || "Passwords matched!"}
                    </div> : ""}
                  {!isPasswordMatched && this.state.password && this.state.confirmPassword && isValidConfirmPassword ?
                    <div className="dxAuth-pwMismatch">
                      <i className="fa fa-x text-danger"></i>&nbsp;{changePasswordDict[lang]["Not Matched"] || "Not Matched"}
                    </div> : ""}
                  {isValidConfirmPassword ? "" :
                    <div className="dxAuth-pwError">
                      {notValidConfirmPasswordText}
                    </div>}
                </div>

                <div className="dxAuth-checkboxRow">
                  <input
                    type="checkbox"
                    name='myCheckbox'
                    onChange={(e) => this.setState({ policy: e.target.checked })}
                    required
                    onInvalid={(e) => {
                      let msg = registerDict[lang]['acceptance_required'];
                      e.target.setCustomValidity(msg)
                    }}
                    onInput={(e) => e.target.setCustomValidity("")}
                  />
                  <span
                    dangerouslySetInnerHTML={{ __html: (pageContent.items[9].title || "I agree to the Privacy Policy.").replace("{brand}", countryConfig.brandName) }}
                  />
                </div>

                {/* token expire div view */}
                <div className="alert alert-danger dxAuth-tokenExpire" id='view_tokenexpire' role="alert" style={{ display: 'none' }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                    <p>{pageContent.items[33].title}</p>
                    <button type='button' className='btn btn-outline-danger' onClick={() => window.location.reload()}>ok</button>
                  </div>
                </div>

                <Show when={this.state.show === true}>
                  <p className="dxAuth-formError privacy_error">
                    {pageContent.items[13].title}
                  </p>
                </Show>
                <Show when={this.state.showConfirmPassword === true}>
                  <p className="dxAuth-formError privacy_error">
                    {pageContent.items[14].title}
                  </p>
                </Show>
                <Show when={this.state.error.status === true}>
                  <p className="dxAuth-formError privacy_error">
                    {this.state.error.message}
                  </p>
                </Show>

                {process.env.REACT_APP_DISABLE_CAPTCHA !== 'true' && (
                <div className="dxAuth-captchaRow">
                  <SimpleCaptcha
                    onValid={this.setCaptcha}
                    updateCaptcha={this.updateCaptcha}
                    language={this.props.language}
                    style={{ borderRadius: "0.75rem" }}
                  />
                </div>
                )}

                <LoadingSpinner show={this.props.isLoading} />

                <button
                  type="submit"
                  className="dxAuth-primaryBtn"
                  onClick={this.handleButtonClick}
                  disabled={this.state.isButtonDisabled || !this.isSubmitButtonDisable()}
                >
                  <span className="dxAuth-primaryBtn-label">{pageContent.items[11].title}</span>
                  {/* ===== DISABLED 2026-05-04 — Auth button arrow icon =====
                      Client requested removal. To re-enable: unwrap.
                      ====================================================== */}
                  {/* <img src={signUpImg} alt="" className="dxAuth-primaryBtn-arrow" /> */}
                </button>

                <p className="dxAuth-bottomLink">
                  {pageContent.items[1].title}
                  <Link
                    to="#"
                    onClick={() => this.onLogin()}
                    className="dxAuth-bottomLink-cta"
                  >
                    {pageContent.items[2].title}
                  </Link>
                </p>

                {/* Pinned top-right via .dxAuth-langDropdown (position: fixed,
                    with a mobile `position: static` fallback in Login.css).
                    LanguageToggle renders nothing on en-only portals. */}
                <div className="dxAuth-langDropdown">
                  <LanguageToggle />
                </div>
              </form>
            </div>
          </main>
        </section>
        <ToastContainer position="top-right" autoClose={5000} newestOnTop closeOnClick pauseOnHover />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuth: state.adminUser.adminUser.isAuthenticated,
    token: state.adminUser.adminUser.token,
    language: state.adminUser.adminUser.language,
    isLoading: state.adminUser.adminUser.loading,
    error: state.adminUser.adminUser.error,
    state: state,
  };
};

const RegistrationWithState = withRouter(connect(
  mapStateToProps, { authRegistration },
)(Registration));

Registration.propTypes = {
  language: PropTypes.string,
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  authRegistration: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};

export {
  Registration,
  RegistrationWithState,
};
